import React from 'react';
import WelcomeMessage from './Templates/WelcomeMessage';
import { useSelector } from 'react-redux';
import { sproutsAgentSelector } from 'src/store/sprouts-agent/sprouts-agent.selector';
import { messageType } from 'src/store/sprouts-agent/types';
import SimpleText from './Templates/SimpleText';
import PaulaIcon from 'src/assets/icons/paula-animaton-icon.png';
import CreateAgent from './Templates/CreateAgent';
import AiStartAnimation from 'src/components/AiStarAnimation';
import TableData from './Templates/TableData';
import Tooltip from 'src/components/Tooltip';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import CopyAllOutlined from '@mui/icons-material/CopyAllOutlined';
import { IconButton } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DownloadCSV from './Templates/DownloadCSV';
interface MessageProps {
  audioRef: any;
  handleTimeUpdateRef: any;
  abortControllerRef: any;
}
const MessageSection: React.FC<MessageProps> = ({
  abortControllerRef,
  audioRef,
  handleTimeUpdateRef,
}) => {
  const chatContainerRef = React.useRef<HTMLDivElement>(null);
  const { messages, audioVisualizerOpen } = useSelector(sproutsAgentSelector);
  const [userAtBottom, setUserAtBottom] = React.useState(true);
  React.useEffect(() => {
    if (messages?.length > 0 && userAtBottom) {
      chatContainerRef.current?.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [messages, userAtBottom]);
  const scrollToBottom = () => {
    chatContainerRef.current?.scrollTo({
      top: chatContainerRef.current.scrollHeight,
      behavior: 'smooth',
    });
  };
  React.useEffect(() => {
    const ref = chatContainerRef.current;
    if (!ref) return;

    const handleScroll = () => {
      if (!chatContainerRef?.current) return;
      const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
      const isAtBottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= 50;
      setUserAtBottom(isAtBottom);
    };
    ref.addEventListener('scroll', handleScroll);
    return () => ref.removeEventListener('scroll', handleScroll);
  }, [messages]);
  return (
    <div className={`message-section ${(messages.length > 0 || audioVisualizerOpen) && 'extend'}`} ref={chatContainerRef}>
      {messages?.length === 0 ? (
        // <WelcomeMessage />
        <></>
      ) : (
        messages?.map((msg: messageType, idx: number) => {
          if (msg.role === 'user') {
            return <SimpleText content={msg.content} key={idx} />;
          } else {
            return (
              <ResponseContainer
                idx={idx}
                key={idx}
                content={msg.content}
                contentType={msg.contentType}
                summarizedText={msg.summarizedText}
                audioRef={audioRef}
                handleTimeUpdateRef={handleTimeUpdateRef}
                abortControllerRef={abortControllerRef}
              />
            );
          }
        })
      )}
      <IconButton
        style={{
          position: 'fixed',
          bottom: '170px',
          opacity: userAtBottom ? 0 : 0.8,
          transition: 'all 0.5s ease-in-out',
          right: '40%',
          transform: 'translateX(-50%)',
          backgroundColor: '#dddddd',
          zIndex: '10',
        }}
        onClick={scrollToBottom}
      >
        <ArrowDownwardIcon fontSize="small" />
      </IconButton>
    </div>
  );
};
interface ResponseType {
  content: string;
  contentType: string;
  idx: number;
  summarizedText?: string;
  audioRef: any;
  handleTimeUpdateRef: any;
  abortControllerRef: any;
}
const ResponseContainer: React.FC<ResponseType> = ({ content, contentType, idx }) => {
  const [showCopied, setShowCopied] = React.useState(false);
  const [isMessageHovered, setIsMessageHovered] = React.useState(false);
  const handleCopy = (liveUrl: string) => {
    navigator.clipboard.writeText(liveUrl);
  };
  return (
    <div className="response-container">
      <img src={PaulaIcon} height={50} width={50} />
      <div
        className="response"
        onMouseEnter={() => setIsMessageHovered(true)}
        onMouseLeave={() => setIsMessageHovered(false)}
      >
        {content === 'codeword_123' ? (
          <p style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>Please try again!</p>
        ) : !content || content.trim().length === 0 ? (
          <p style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <AiStartAnimation />
            Fetching response...
          </p>
        ) : contentType === 'sdi_agent' ? (
          <TableData message={content} idx={idx}/>
        ) : contentType === 'download_csv_tool' ? (
          <DownloadCSV message={content} />
        ) : (
          <CreateAgent message={content} />
        )}

        {/* <div className="copy-icon">
          {showCopied && isMessageHovered ? (
            <Tooltip title="Copied" placement="top">
              <CheckOutlined
                style={{
                  cursor: 'pointer',
                  height: '12px',
                  width: '12px',
                }}
              />
            </Tooltip>
          ) : (
            isMessageHovered && (
              <Tooltip title="Copy" placement="top">
                <CopyAllOutlined
                  onClick={() => {
                    const copyContent = content;
                    handleCopy(copyContent);
                    setShowCopied(true);
                    setTimeout(() => {
                      setShowCopied(false);
                    }, 700);
                  }}
                  style={{
                    cursor: 'pointer',
                    height: '12px',
                    width: '12px',
                  }}
                />
              </Tooltip>
            )
          )}
        </div> */}
      </div>
    </div>
  );
};
export default MessageSection;
